export default {
    methods: {
        changeLocale() {
            this.$i18n.locale = this.$i18n.locale === 'ja' ? 'en' : 'ja';
        },
        toggleOperationType: async function () {
            this.$store.state.operation_type = this.$store.state.operation_type === 0 ? 1 : 0;
        },
        openDialog: async function () {
            console.log('This is a openDialog');
        },
        mixinMethod() {
            console.log('This is a method from the mixin.');
        }
    }
};